// 履歴レコメンド：購入履歴の帽子から形状・球団を判定し、候補の帽子を取得して横スクロールで表示する
// 判定ルールは homegame/analysis/history-reco-202610/classify.py と同じ（2025年の注文で検証済み）
(() => {
  if (customElements.get('history-reco')) return;

  const HAT_TYPE = 'CAPS HATS/帽子';
  const ITEMS_SECTION = 'history-reco-items';
  const MAX_ITEMS = 12;

  // 形状：長い名前から順に判定する（59FIFTY の中に 9FIFTY が含まれるため）
  // [表示名, パターン, コレクションhandle, 種類]
  const SHAPES = [
    ['19TWENTY', /\b19TWENTY\b/, '19twenty', 'adjustable'],
    ['39THIRTY', /\b39THIRTY\b/, null, 'fitted'],
    ['59FIFTY', /\b59FIFTY\b/, '59fifty', 'fitted'],
    ['9FORTY', /\b9FORTY\b/, '9forty', 'adjustable'],
    ['9TWENTY', /\b9TWENTY\b/, '9twenty', 'adjustable'],
    ['9FIFTY', /\b9FIFTY\b/, '9fifty', 'adjustable'],
    ['9THIRTY', /\b9THIRTY\b/, '9thirty', 'adjustable'],
    ['9SEVENTY', /\b9SEVENTY\b/, null, 'adjustable'],
    ['ビーニー', /BEANIE|KNIT\s?CAP|ビーニー|ニット帽/, 'new-era-beanie', 'knit'],
  ];

  // 判定の前に消す、MLB以外のチーム名
  const NOT_MLB =
    /DETROIT\s?(LIONS|PISTONS|RED\s?WINGS)|NEW\s?YORK\s?RANGERS|CHIBA\s?LOTTE\s?MARINES?|LOS\s?ANGELE?S\s?(KINGS|LAKERS|RAMS|CHARGERS|CLIPPERS)|EAST\s?CAROLINA\s?PIRATES|CUBAN\s?X-?GIANTS|YOMIURI\s?GIANTS|読売ジャイアンツ|HANSHIN\s?TIGERS|阪神タイガース|NEW\s?YORK\s?GIANTS?|SAN\s?FRANCISCO\s?49ERS|\bNHL\b|\bNFL\b|\bNBA\b|\bNPB\b/g;

  // [球団タグ, 見出しの表示名, 商品名のパターン]。前身球団は今の球団に寄せる
  const TEAMS = [
    ['New York Yankees', 'Yankees', /YANKEES|ヤンキース|\bNYY\b|HIGHLANDERS/],
    ['Los Angeles Dodgers', 'Dodgers', /DODGERS|DOGERS|ドジャース/],
    ['New York Mets', 'Mets', /\bMETS\b|メッツ/],
    ['San Diego Padres', 'Padres', /PADRES|パドレス/],
    ['Boston Red Sox', 'Red Sox', /RED\s?SOX|レッドソックス/],
    ['Chicago White Sox', 'White Sox', /WHITE\s?SOX|ホワイトソックス/],
    ['Seattle Mariners', 'Mariners', /MARINERS|マリナーズ/],
    ['Detroit Tigers', 'Tigers', /DETROIT|DETOROIT|デトロイト/],
    ['Houston Astros', 'Astros', /ASTROS|アストロズ/],
    ['Atlanta Braves', 'Braves', /BRAVES|ブレーブス/],
    ['Chicago Cubs', 'Cubs', /\bCUBS\b|カブス/],
    ['San Francisco Giants', 'Giants', /SF\s?GIANTS|SAN\s?FRANCISCO|サンフランシスコ/],
    ['Los Angeles Angels', 'Angels', /\bANGELS\b|エンゼルス/],
    ['Oakland Athletics', 'Athletics', /ATHLETICS|\bA'S\b|アスレチックス/],
    ['St. Louis Cardinals', 'Cardinals', /CARDINALS|カージナルス/],
    ['Philadelphia Phillies', 'Phillies', /PHILLIES|PHILLY|フィリーズ/],
    ['Baltimore Orioles', 'Orioles', /ORIOLES|オリオールズ/],
    ['Pittsburgh Pirates', 'Pirates', /PIRATES|パイレーツ/],
    ['Cincinnati Reds', 'Reds', /\bREDS\b|レッズ/],
    ['Colorado Rockies', 'Rockies', /ROCKIES|ロッキーズ/],
    ['Minnesota Twins', 'Twins', /\bTWINS\b|ツインズ/],
    ['Milwaukee Brewers', 'Brewers', /BREWERS|ブルワーズ/],
    ['Arizona Diamondbacks', 'Diamondbacks', /DIAMONDBACKS|D-?BACKS|ダイヤモンドバックス/],
    ['Miami Marlins', 'Marlins', /MARLINE?S|マーリンズ/],
    ['Washington Nationals', 'Nationals', /NATIONALS|ナショナルズ|EXPOS/],
    ['Texas Rangers', 'Rangers', /RANGERS|レンジャーズ/],
    ['Tampa Bay Rays', 'Rays', /\bRAYS\b|レイズ/],
    ['Kansas City Royals', 'Royals', /ROYALS|ロイヤルズ/],
    ['Cleveland Guardians', 'Guardians', /GUARDIANS|ガーディアンズ|INDIANS|インディアンス/],
    ['Toronto Blue Jays', 'Blue Jays', /BLUE\s?JAYS|ブルージェイズ/],
  ];

  const handleize = (text) =>
    text
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/^-+|-+$/g, '');

  const shapeOf = (title) => {
    const upper = title.toUpperCase();
    const hit = SHAPES.find(([, pattern]) => pattern.test(upper));
    return hit ? { label: hit[0], handle: hit[2], kind: hit[3] } : null;
  };

  // 球団タグが取れればそれを優先。取れなければ商品名で、複数当たったら先頭に近い方
  const teamOf = (title, tags) => {
    const byTag = TEAMS.find(([tag]) => Array.isArray(tags) && tags.includes(tag));
    if (byTag) return byTag;
    const upper = title.toUpperCase().replace(NOT_MLB, ' ');
    let best = null;
    TEAMS.forEach((team) => {
      const match = team[2].exec(upper);
      if (match && (!best || match.index < best.index)) best = { index: match.index, team };
    });
    return best ? best.team : null;
  };

  // 帽子かどうか：商品が取れれば商品タイプ、取れなければ商品名の形状名だけで判定する
  const isHat = (item) => (item.type ? item.type === HAT_TYPE : Boolean(shapeOf(item.title || '')));

  // 最新の注文の中で最後に出てくる帽子
  const latestHat = (orders) => {
    const sorted = [...orders].sort((a, b) => Number(b.created_at) - Number(a.created_at));
    for (const order of sorted) {
      const hats = (order.items || []).filter(isHat);
      if (hats.length) return hats[hats.length - 1];
    }
    return null;
  };

  // 取りに行くコレクションのURL（上から順に、足りなければ次で補充）と見出し
  const planFor = (hat) => {
    if (!hat) return null;
    const shape = shapeOf(hat.title || '');
    const team = teamOf(hat.title || '', hat.tags);
    const teamHandle = team ? handleize(team[0]) : null;

    if (shape && shape.kind === 'adjustable' && shape.handle) {
      const urls = teamHandle ? [`collections/${shape.handle}/${teamHandle}`] : [];
      urls.push(`collections/${shape.handle}`);
      return { urls, heading: ['shape', shape.label] };
    }
    if (shape && shape.kind === 'knit') {
      return { urls: [`collections/${shape.handle}`], heading: ['shape', shape.label] };
    }
    if (team) {
      return {
        urls: [`collections/${teamHandle}/59fifty`, `collections/${teamHandle}/new-era`, `collections/${teamHandle}`],
        heading: ['team', team[1]],
      };
    }
    if (shape && shape.label === '59FIFTY') {
      return { urls: ['collections/59fifty'], heading: ['shape', shape.label] };
    }
    return null;
  };

  class HistoryReco extends HTMLElement {
    connectedCallback() {
      if (this.started) return;
      this.started = true;
      this.run().catch(() => this.finish([]));
    }

    async run() {
      let orders = [];
      try {
        orders = JSON.parse(this.querySelector('[data-history-reco-orders]').textContent);
      } catch (error) {
        orders = [];
      }

      // 購入済みと表示中の商品は出さない
      this.excluded = new Set(
        orders.flatMap((order) => (order.items || []).map((item) => String(item.product_id))).filter(Boolean)
      );
      if (this.dataset.currentProduct) this.excluded.add(this.dataset.currentProduct);

      const plan = planFor(latestHat(orders));
      let items = plan ? await this.collect(plan.urls) : [];
      let heading = plan ? plan.heading : null;

      if (!items.length) {
        items = await this.collect([`collections/${this.dataset.fallback}`]);
        heading = ['fallback', ''];
      }
      this.setHeading(heading);
      this.finish(items);
    }

    async collect(urls) {
      const items = [];
      const seen = new Set();
      for (const url of urls) {
        if (items.length >= MAX_ITEMS) break;
        for (const li of await this.fetchItems(url)) {
          const id = li.dataset.productId;
          if (seen.has(id) || this.excluded.has(id)) continue;
          seen.add(id);
          items.push(li);
          if (items.length >= MAX_ITEMS) break;
        }
      }
      return items;
    }

    async fetchItems(path) {
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const response = await fetch(`${root}${path}?section_id=${ITEMS_SECTION}&sort_by=created-descending`);
      if (!response.ok) return [];
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      return Array.from(html.querySelectorAll('[data-product-id]'));
    }

    setHeading(heading) {
      const [kind, value] = heading;
      const template =
        kind === 'shape'
          ? this.dataset.headingShape
          : kind === 'team'
          ? this.dataset.headingTeam
          : this.dataset.headingFallback;
      this.querySelector('[data-history-reco-heading]').textContent = template
        .replace('{shape}', value)
        .replace('{team}', value);
    }

    finish(items) {
      this.classList.remove('is-loading');
      if (!items.length) {
        this.hidden = true;
        return;
      }
      const sectionId = this.dataset.sectionId;
      const slider = this.querySelector('[data-history-reco-slider]').content.cloneNode(true);
      const list = slider.querySelector('ul');
      items.forEach((li, index) => {
        li.id = `Slide-${sectionId}-${index + 1}`;
        // カード内のIDを候補セクションのものから自分のセクションIDに置き換える（同じページに複数置けるように）
        list.insertAdjacentHTML('beforeend', li.outerHTML.split(ITEMS_SECTION).join(sectionId));
      });
      slider.querySelector('.slider-counter--total').textContent = items.length;
      this.querySelector('[data-history-reco-body]').appendChild(slider);
    }
  }

  customElements.define('history-reco', HistoryReco);
})();
